module.exports = __webpack_public_path__ + "static/media/popup-slow.822f8ef8.wav";